import { createFileRoute } from "@tanstack/react-router";

import { HomePage } from "../../features/home/HomePage";
import { useConnectionOutcome } from "../../features/instagram/outcome";
import { validateOutcomeSearch } from "../../features/instagram/outcomeSearch";

export const Route = createFileRoute("/_app/")({
  validateSearch: validateOutcomeSearch,
  component: function Home() {
    return <HomePage outcome={useConnectionOutcome(Route.useSearch())} />;
  },
});
